import { NgModule } from '@angular/core';
import { CartPage } from './cart.page';
import { CommonModule } from '@angular/common';
import { CartRoutingModule } from './cart-routing.module';
import { CartItemComponent } from './cart-item.component';
import { CartHeaderComponent } from './cart-header.component';
import { CartFooterComponent } from './cart-footer.component';
import { CartItemEditComponent } from './cart-item-edit.component';
import { ReactiveFormsModule } from '@angular/forms';
import { CouponModalComponent } from './coupon-modal.component';
import { NotesModalComponent } from './notes-modal.component';
import { CustomerModalComponent } from './customer-modal.component';
import { CartContentComponent } from './cart-content.component';
import { CoreModule } from '../core/core.module';
import { CustomerSelectorComponent } from './cart-customer-selector.component';
import { CustomerItemComponent } from './customer-item.component';
import { ReceiptComponent } from './receipt.component';

@NgModule({
  imports: [
    CommonModule,
    CartRoutingModule,
    ReactiveFormsModule,
    CoreModule
  ],
  declarations: [
    CartPage,
    CartItemComponent,
    CartHeaderComponent,
    CartFooterComponent,
    CartItemEditComponent,
    CouponModalComponent,
    NotesModalComponent,
    CustomerModalComponent,
    CartContentComponent,
    CustomerSelectorComponent,
    CustomerItemComponent,
    ReceiptComponent,
  ],
  exports: [
    CartPage,
    CartHeaderComponent,
    CartContentComponent,
    CustomerItemComponent,
    ReceiptComponent,
  ],
  providers: []
})
export class CartModule {
}
